<header
    (click)="toggleExpansion()"
    class="head pl-2 pt-3 pr-2"
    [ngClass]="isExpanded ? 'pb-4' : 'pb-3'"
>
    <app-icon type="PlusCircle" *ngIf="!isExpanded"></app-icon>
    <app-icon type="MinusCircle" *ngIf="isExpanded"></app-icon>
    <h4 class="title ml-3">{{ accordionTitle }}</h4>
</header>
<section [ngClass]="isExpanded ? 'd-block' : 'd-none'" class="pb-3 mr-2">
    <ng-content></ng-content>
    <button class="show-more-button mt-2" (click)="toggleShowMore()" *ngIf="isShowAllButtonVisible">
        {{ allItemsVisible ? "- See Less" : "+ See All" }}
    </button>
</section>
